<template>
   <div class="text-left">
        <!-- <div v-if="isAdmin">
            <h4 class="bg-base p-3 text-left">{{queryCon.look == 0 ? '注册人' : '编辑'}}信息</h4>
            <div class="p-3 pt-4 w-40 text-left">
                <div v-if="queryCon.look != 0">
                    <div class="d-center-start mb-3"><left-text leftText="对接人" />
                        <el-select size="small"
                            v-model="StoreBasicInfo.person_liable_id" class="w-40" placeholder="设置导游对接人">
                            <el-option v-for="item in staffListArr"
                                    :key="item.id"
                                    :label="item.truename"
                                    :value="item.id" />
                        </el-select>
                    </div>
                    <div class="d-center-start mb-3"><left-text leftText="是否显示" />
                        <el-radio v-model="StoreBasicInfo.display" label="1">是</el-radio>
                        <el-radio v-model="StoreBasicInfo.display" label="0">否</el-radio>
                    </div>
                </div>
                <div class="d-center-start mb-3" v-if="StoreBasicInfo.user.truename">
                    <left-text leftText="联系人" />{{StoreBasicInfo.user.truename}}
                    <span v-if="queryCon.look == 0" class="text-link ml-5" @click="goDetailList">查看资金流水</span>
                </div>
                <div class="d-center-start mb-3"><left-text leftText="注册人电话" />{{StoreBasicInfo.userArr.mobile}}</div>
                <div v-if="queryCon.look == 0">
                    <div class="d-center-start mb-3"><left-text leftText="注册时间" />{{StoreBasicInfo.time | formatTimestamp(1)}}</div>
                    <div class="d-center-start mb-3"><left-text leftText="认证状态" />{{StoreBasicInfo.verify | formatVar('verifyType')}}</div>
                </div>
            </div>
        </div> -->
        <div v-if="queryCon.look == 0 && isAdmin">
            <h4 class="bg-base p-3 text-left">活跃信息</h4>
            <div class="pl-3">
                <div class="d-center-start mt-3 mb-3"><left-text leftText="已接团数" />{{StoreBasicInfo.msg.guide_order_nos || 0}} 次</div>    
                <div class="d-center-start mb-3"><left-text leftText="累计付款" />{{(StoreBasicInfo.msg.guide_pay_moneys / 100).toFixed(2) || 0.00}} 元</div>    
                <div class="d-center-start mb-3">
                    <left-text leftText="累计节省" />{{Stotal}} 元
                    <span class="text-link ml-5" @click="$router.push({name: 'SaveList',query:{uid: StoreBasicInfo.uid}})">查看节省流水</span>
                </div>    
            </div>
        </div>
        <h4 class="bg-base p-3 text-left">导游信息</h4>
        <div class="pl-3">
            <div class="mt-3 d-center-start" v-if="StoreBasicInfo.user"><left-text leftText="导游名称"/>{{StoreBasicInfo.user.truename}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="真实姓名"/>{{StoreBasicInfo.title}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="性别"/> {{StoreBasicInfo.sex | formatVar('sex')}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="所在机构"/>{{StoreBasicInfo.institution}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="从业年限"/>{{StoreBasicInfo.work_seniority}}年</div>
            <div class="mt-3 d-center-start" v-if="Number(StoreBasicInfo.level) > 0"><left-text leftText="导游等级"/>{{StoreBasicInfo.level | formatVar('guideLevel')}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="身份证号"/>{{StoreBasicInfo.id_card}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="手机号"/>{{StoreBasicInfo.mob}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="联系地址"/>{{StoreBasicInfo.province_name}} / {{StoreBasicInfo.city_name}} / {{StoreBasicInfo.district_name}} / {{StoreBasicInfo.address}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="语种"/>{{StoreBasicInfo.language}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="导游证号"/>{{StoreBasicInfo.guide_num}}</div>
            <div class="mt-3 d-center-start"><left-text leftText="导游证"/>
                <img class="rounded cursor-pointer" v-lazy="ImgPreUrl + StoreBasicInfo.guide_pic"
                 width="150" height="150" @click="imgPreview" />
            </div>
            <div class="mt-2 mb-5 d-center-start"><left-text leftText="带团经历"/>{{StoreBasicInfo.lead_experience}}</div>
        </div>
        <div class="text-center" v-if="JSON.stringify(queryCon).indexOf('i') > 5 && queryCon.look != 0">
          <!-- <el-button size="small">取消</el-button> -->
          <el-button type="success" @click="submitForm">确定</el-button>
        </div>
   </div>
</template>

<script>
import { UploadImages } from '@/assets/utils/uploadFiles'
import { mapState,mapGetters,mapActions } from 'vuex'
export default {
    name: 'GuideBaseInfo',
    computed: {
        ...mapState(['StoreBasicInfo', 'staffLists', 'userLoginMessage']),
        ...mapGetters(['isAdmin']),
        queryCon() { return this.$route.query },
        //业务负责人备选项
        staffListArr() {
            let arr = $.extend(true, [], this.staffLists.lists);
            arr.unshift({
                id:0,
                truename:'无'
            })
            return arr;
        },
    },
    data () {
        return {
            Stotal: 0,
            showPassword: false
        }
    },
    watch: {
        StoreBasicInfo (){
            if(this.isAdmin) this.getGuideSave()
        }
    },
    created () { this.getUserStaffLists({num:100}) },
    methods: {
        ...mapActions(['getUserStaffLists','verifyStore']),
        //查看支付明细和积分明细
        goDetailList() {
            let routeUrl = this.$router.resolve({
                name:'DetailList',
                query:{
                    type: 1,
                    storeType:4,
                    storeId: this.StoreBasicInfo.id,
                    storeName: this.StoreBasicInfo.title
                }
            });
            window.open(routeUrl.href, '_blank');
        },
        submitForm () {
            let data = {
                store_id: this.$route.query.id,
                verify: this.StoreBasicInfo.verify,
                display: this.StoreBasicInfo.display,
                person_liable_id:this.StoreBasicInfo.person_liable_id,
                level: this.StoreBasicInfo.level
            };
            this._confirm('确认操作么？',() => {
                this.verifyStore({
                    data,
                    successFun:() => {}
                });
            })
        },
        // 导游时的累计节省
        async getGuideSave () {
            // let resData = await this.$axios.post('/pc/Common/getUsedRedPack', {
            //     uid: this.StoreBasicInfo.uid
            // });
            // if (resData.code === '00000') this.Stotal = resData.data
        },
        // 图片放大
        imgPreview(index) {
            this._CarouselView({
                currentImg: 0,
                picArray: [this.StoreBasicInfo.guide_pic]
            })
        },
    }
}
</script>
